var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"baseMarkdown",staticClass:"base-markdown",class:_vm.divClass,domProps:{"innerHTML":_vm._s(_vm.markedHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }